import {
  Box,
  Button,
  FormHelperText,
  Grid,
  InputAdornment,
  OutlinedInput,
  Paper,
  Typography,
} from "@mui/material";
import { useState } from "react";
import * as yup from "yup";
import { Field, Formik } from "formik";
import axios from "axios";
import { useLoginStore } from "../../Utils/Store";
import { useNavigate, useLocation } from "react-router-dom";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Snackbar from "../../components/Snackbar/Snackbar";

const LoginForm = () => {
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("");

  const setUser = useLoginStore((state) => state.setUser);

  const navigate = useNavigate();
  const location = useLocation();

  const redirectPath = location.state?.path || "/home";

  const initialValues = {
    username: "",
    password: "",
  };

  // const handleKeyPress = (e) => {
  //   if (e.key === "Enter") {
  //     handleLogin();
  //   }
  // };

  const checkoutSchema = yup.object().shape({
    username: yup.string().required("required"),
    password: yup
      .string()
      .trim() // Trim leading/trailing whitespace
      .required("password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
        "Password must contain letters and numbers"
      ),
  });

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#ebeeef",
      }}
    >
      <Box sx={{ width: "50%" }}>
        <Paper elevation={8} sx={{ borderRadius: "10px" }}>
          <Grid
            container
            display="flex"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
          >
            <Grid size={6}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
                sx={{
                  padding: "10px",
                }}
              >
                <img
                  alt="profile-user"
                  width="100%"
                  height="100%"
                  src={`../../assets/Calling.png`}
                />
              </Box>
            </Grid>
            <Grid size={6}>
              <Box sx={{ paddingRight: "50px" }}>
                <Typography variant="h4" fontWeight="bold">
                  PRYCE SMS
                </Typography>
                <Typography marginBottom="40px" color="gray">
                  Please enter your details.
                </Typography>
                <Formik
                  onSubmit={async (values, { setSubmitting, resetForm }) => {
                    try {
                      let payload = {
                        username: values.username,
                        password: values.password,
                      };

                      const response = await axios.post(
                        process.env.REACT_APP_LOGIN,
                        payload
                      );

                      if (response.data.success) {
                        const userData = response.data.user;
                        setUser(userData);
                        navigate(redirectPath, { replace: true });
                      } else {
                        setSnackbarMessage("Invalid credentials");
                        setSnackbarType("error");
                        setSnackbarStatus(true);
                        resetForm();
                      }
                    } catch (error) {
                      console.log("Error:", error);
                      setSnackbarMessage("Invalid credentials");
                      setSnackbarType("error");
                      setSnackbarStatus(true);
                      resetForm();
                    }
                  }}
                  initialValues={initialValues}
                  validationSchema={checkoutSchema}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Field name="username">
                        {({ field, meta }) => (
                          <Box>
                            <OutlinedInput
                              fullWidth
                              type="text"
                              placeholder="Username"
                              sx={{ gridColumn: "span 2" }}
                              startAdornment={
                                <InputAdornment position="start">
                                  <AccountCircleOutlinedIcon />
                                </InputAdornment>
                              }
                              {...field}
                              onBlur={handleBlur}
                              error={meta.touched && !!meta.error}
                              value={values.username}
                            />
                            {meta.touched && meta.error && (
                              <FormHelperText error>
                                {meta.error}
                              </FormHelperText>
                            )}
                          </Box>
                        )}
                      </Field>
                      <Field name="password">
                        {({ field, meta }) => (
                          <Box style={{ marginTop: "15px" }}>
                            <OutlinedInput
                              fullWidth
                              type="password"
                              placeholder="Password"
                              sx={{ gridColumn: "span 2" }}
                              startAdornment={
                                <InputAdornment position="start">
                                  <LockOutlinedIcon />
                                </InputAdornment>
                              }
                              {...field}
                              onBlur={handleBlur}
                              error={meta.touched && !!meta.error}
                              value={values.password}
                            />
                            {meta.touched && meta.error && (
                              <FormHelperText error>
                                {meta.error}
                              </FormHelperText>
                            )}
                          </Box>
                        )}
                      </Field>
                      <Box display="flex" justifyContent="end" mt="35px">
                        <Button
                          type="submit"
                          color="primary"
                          variant="contained"
                          disabled={isSubmitting}
                          fullWidth
                          // onClick={handleLogin}
                          // onKeyDown={handleKeyPress}
                        >
                          Sign in
                        </Button>
                      </Box>
                    </form>
                  )}
                </Formik>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
      <Snackbar
        messages={snackbarMessage}
        status={snackbarStatus}
        setStatus={setSnackbarStatus}
        snackbarRef={snackbarType}
      />
    </Box>
  );
};

export default LoginForm;
